import { InputLabel, MenuItem } from '@mui/material';
import { memo, useEffect } from 'react';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { RefCitizenshipData } from 'shell/models/ref-citizenship';

interface SelectRefCitizenshipProps {
  disabled?: boolean;
  value: string;
  onChange: (event: string) => void;
  id: string;
  label?: string;
  error?: boolean;
  isSmallSize?: boolean;
  cdUsecase?: string;
  required?: boolean;
}

const SelectRefCitizenshipComponent = ({
  disabled = false,
  onChange,
  value,
  id,
  label = 'Numero legge cittadinanza',
  error = false,
  isSmallSize = false,
  cdUsecase,
  required = false,
}: SelectRefCitizenshipProps): React.ReactElement => {
  const [laws, getLaws] = useHttpFetch<HttpResponse<Array<RefCitizenshipData>>, Array<ItemVM>>(
    `${__ACT_API_URL__}/norme-cittadinanza-usecase/list`,
    {
      onBootstrap: false,
      options: {
        method: 'POST',
      },
      transformer: (response) =>
        (response?.data?.payload || []).map((item) => ({
          id: item.idMotivoVariazioneCittadinanza,
          value: `${item.descrizione || ''} ${
            item.descrizioneBreve ? `(${item.descrizioneBreve})` : ''
          }`,
        })),
    }
  );

  const lawsData = (laws.data as Array<ItemVM>) || [];

  useEffect(() => {
    if (cdUsecase) {
      getLaws({ data: { cdUsecase } });
    }
  }, [cdUsecase]);

  useEffect(() => {
    // se torna un solo valore va salvato subito
    if (lawsData.length === 1) {
      onChange(lawsData[0].id.toString());
    }
  }, [lawsData]);

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error}>{`${label} ${required ? '*' : ''}`}</InputLabel>
      <PmiSelect
        error={error}
        id={id}
        name={id}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        disabled={disabled}
        label={label}
        size={isSmallSize ? 'small' : undefined}
      >
        {lawsData.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

SelectRefCitizenshipComponent.displayName = 'List Ref Citizenship component';

const SelectRefCitizenship = memo(SelectRefCitizenshipComponent);

export default SelectRefCitizenship as typeof SelectRefCitizenshipComponent;
